export const tableStyles = {
  cell: {
    borderBottom: '1px solid rgba(145, 158, 171, 0.12)',
    color: 'rgb(145, 158, 171)',
    fontWeight: 600,
    fontSize: '0.875rem',
    padding: '16px 8px',
    '&:first-of-type': {
      paddingLeft: 24
    },
    '&:last-of-type': {
      paddingRight: 24
    }
  },
  row: {
    '&:hover': { 
      bgcolor: 'rgba(145, 158, 171, 0.08)' 
    },
    '& td': { 
      color: 'rgb(255, 255, 255)', 
      fontSize: '0.875rem',
      borderBottom: '1px solid rgba(145, 158, 171, 0.12)'
    }
  },
  checkbox: {
    color: 'rgb(145, 158, 171)',
    '&.Mui-checked': {
      color: 'rgb(0, 184, 217)'
    },
    padding: '0 8px'
  },
  status: {
    backgroundColor: 'rgba(84, 214, 44, 0.16)',
    color: 'rgb(84, 214, 44)',
    display: 'inline-block',
    px: 1,
    py: 0.5,
    borderRadius: 1,
    fontSize: '0.75rem',
    fontWeight: 700
  },
  sparklineCell: {
    borderBottom: '1px solid rgba(145, 158, 171, 0.12)',
    minWidth: 120,
    padding: '8px 8px'
  }
}; 